import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import App2 from './App2';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);